import * as React from "react";
import Dragula from "react-dragula";

import {cs}                         from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {Load2}                      from "@Common/react/load2";
import {rLsStore}                   from "@Common/react/ls-store";
import {UseState}                   from "@Common/react/use-state";
import {AlertModal}                 from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";
import {Responsive}                 from "@Common/ui-components/responsive";
import {faSpinner}                  from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";
import {rFolderTiles}               from "./common/folder-tiles/folder-tiles";
import {UserCreatedAdminLayout}     from "./common/layout/user-created-admin-layout";
import {TemplateUploadModal}        from "./template-upload-modal/template-upload-modal";

export const UserCreatedAdminPublicRoute = ({}) => cs(
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    ["alertModal", ({}, next) => AlertModal({next})],
    ["forceUpdate", (_, next) => UseState({next})],
    ["folders", ({apis}, next) => Load2({
        fetch: () => apis.next.userCreated.getFolders(0, 'public'),
        next,
    })],
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
            lg: 1920,
        },
        next,
    }}/>],
    ["showInactive", (_, next) => rLsStore("uctTiles.showInactiveAdmin", false)({}, next)],
    ["updatingFolderSequence", (_, next) => UseState({next})],
    ["viewMode", ({responsive}, next) => responsive.lt("md") ? next({value: "medium"}) : rLsStore("tiles.viewModeAdmin", "medium")({}, next)],
    ["templateUploadModal",({alertModal}, next) => TemplateUploadModal({
        activeTab: 'public',
        onError: (message) => alertModal.show({message}),
        next,
    })],
    ({folders, showInactive, templateUploadModal, updatingFolderSequence, viewMode}, next) => UserCreatedAdminLayout({
        activeTab: "public", folders, showInactive, templateUploadModal, updatingFolderSequence, viewMode, next
    }),
    ({alertModal, apis, catSubStyle, forceUpdate, folders, responsive, showInactive, templateUploadModal, updatingFolderSequence, viewMode}) => {
        let drake = null;
        const dragulaDecorator = (componentBackingInstance) => {
            if (componentBackingInstance && updatingFolderSequence.value) {
                let options = { mirrorContainer: document.getElementById("dragulaContainer") };
                drake = Dragula([componentBackingInstance], options);
            }
            else {
                drake?.destroy();
            }
        };
        let drakeTemplates = null;
        const dragulaTemplatesDecorator = async (componentBackingInstance) => {
            if (componentBackingInstance) {
                drakeTemplates?.destroy();
                let options = {
                    direction: responsive.lt("md") ? 'vertical' : 'horizontal',
                    mirrorContainer: document.getElementById("dragulaContainer")
                };
                drakeTemplates = Dragula(Array.from(document.getElementsByClassName("folder-content")), options);
                drakeTemplates.on('drop', async (el, target, source) => {
                    let fromFolderIdPrimary = parseInt( source.parentElement.getAttribute('id') );
                    let toFolderIdPrimary = parseInt( target.parentElement.getAttribute('id') );
                    if(fromFolderIdPrimary != toFolderIdPrimary) {
                        [...document.getElementsByClassName("folder-content")].forEach((ele)=>{
                            ele.setAttribute("style", "display: none");
                        });
                        [...document.getElementsByClassName("spinner-footer")].forEach((ele)=>{
                            ele.setAttribute("style", "display: flex");
                        });
                    }
                    let templateIdPrimary = parseInt( el.getAttribute('id') );
                    let templateElements = target.getElementsByClassName("template-card-s7z");
                    let sequenceArray = [];
                    for( const element of templateElements ) {
                        let templateIdPrimary = parseInt( element.getAttribute('id') );
                        if( templateIdPrimary ) {
                            sequenceArray.push(templateIdPrimary);
                        }
                    }
                    let result = await apis.next.userCreated.updateTemplateSequence(sequenceArray);
                    if( result?.errors || result?.errorMessage ) {
                        await alertModal.show({message: "Error saving template sequence."});
                        return;
                    }
                    if(fromFolderIdPrimary != toFolderIdPrimary) {
                        let result = await apis.next.userCreated.updateTemplate({updateFields: {'idPrimary': templateIdPrimary, 'idCategory': toFolderIdPrimary}});
                        if( result?.errors || result?.errorMessage ) {
                            await alertModal.show({message: "Error moving template folder location."});
                            return;
                        }
                        await catSubStyle?.reload();
                        [...document.getElementsByClassName("folder-content")].forEach((ele)=>{
                            ele.removeAttribute("style");
                        });
                        [...document.getElementsByClassName("spinner-footer")].forEach((ele)=>{
                            ele.removeAttribute("style");
                        });
                        drakeTemplates.destroy();
                        forceUpdate.onChange(!forceUpdate.value);
                    }
                });
            }
            else if(drakeTemplates && !componentBackingInstance) {
                drakeTemplates?.destroy();
            }
        };
        return (<>
            {folders.loading ? (
                <div className="spinner-footer" xd-qa-type="label" xd-qa-name="Loading">
                    <FontAwesomeIcon icon={faSpinner} className="fa-pulse"/>
                </div>
            ) : (
                <>
                    <div className="public" ref={dragulaDecorator}>
                        {folders.value.map((folder: any, index) => {return index ? rFolderTiles({
                            activeTab:'public',
                            deleted:0,
                            forceUpdate,
                            index,
                            folder,
                            folders,
                            showInactive: showInactive.value,
                            templateUploadModal,
                            updatingFolderSequence: updatingFolderSequence.value,
                            viewMode: viewMode.value,
                            dragulaTemplatesDecorator}) : '' })}
                    </div>
                    <div id="dragulaContainer"></div>
                </>
            )}
        </>);
    },
);